import { CsContextApiModel } from "../api-models";
import uiConfig from "../ui-config";

// eslint-disable-next-line import/prefer-default-export
export function setSmartSearchDebug(context: CsContextApiModel): void {
  const isInDeveloperMode = uiConfig.nodeEnv === "development";

  const emailsToInclude =
    uiConfig.debugEnabledEmails !== "" ? uiConfig.debugEnabledEmails.split("|") : null;
  if (!emailsToInclude) return;

  const isLoggedIn = !!context?.user?.email;

  function isValidEmail(email: string) {
    return emailsToInclude?.some((str) => email.includes(str) && !email.includes("automated-test"));
  }

  if ((isLoggedIn && isValidEmail(context?.user?.email)) || isInDeveloperMode) {
    // localStorage.setItem("debug", "cs*");
  }
}
